import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import OwlCarousel from "react-owl-carousel2";
import { Link, withRouter } from "react-router-dom";
import {
  appendFollowStatus,
  followButtonClicked,
  unFollowButtonClicked,
  IsEmpty,
  redirectToCompanyUrl,
  redirectToExpertUrl
} from "../../../util/commonFunctions";
import {
  hideLoader,
  showLoader
} from "../../../actions";

class RelatedObjectsSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      needRerender: 0,
      companies: this.props.data.companies != null ? this.props.data.companies : [],
      experts: this.props.data.experts != null ? this.props.data.experts : [],
      isEventUI:  this.props.isEventUI || false,
      company_expert_comb: [],
      options: {
        margin: 12,
        rewind: false,
        autoplay: false,
        dots: false,
        loop: false,
        responsive: {
          1200: {
            items: 3,
            slideBy: 3,
            nav: true
          },
          1199: {
            items: 2,
            slideBy: 2,
            nav: true
          },
          992: {
            items: 2,
            slideBy: 2,
            nav: true
          },
          768: {
            items: 2,
            slideBy: 2,
            nav: true
          },
          480: {
            items: 1,
            slideBy: 1,
            nav: false
          },
          320: {
            items: 1,
            slideBy: 1,
            nav: false
          }
        }
      }
    };
  }

  componentDidMount() {
    if (this.state.companies && this.state.companies?.length > 0 && this.state.experts && this.state.experts?.length > 0) {
      this.setState({ company_expert_comb: [...this.state.experts, ...this.state.companies] })
    } else if (this.state.companies && this.state.companies.length > 0) {
      this.setState({ company_expert_comb: this.state.companies })
    } else if (this.state.experts && this.state.experts.length > 0) {
      this.setState({ company_expert_comb: this.state.experts })
    }

    if (localStorage.getItem("token")) {
      if (this.state.companies && this.state.companies?.length > 0) {
        appendFollowStatus(this.appendFollowCompanyStatusRespHandler, localStorage.getItem("token"), this.state.companies, true);
      }
      if (this.state.experts && this.state.experts?.length > 0) {
        appendFollowStatus(this.appendFollowExpertStatusRespHandler, localStorage.getItem("token"), this.state.experts, false, false, true);
      }
    }

    if (!IsEmpty(localStorage.getItem("followSliderObject"))) {
      let objectId = JSON.parse(localStorage.getItem("followSliderObject")).objectId;
      let objectType = JSON.parse(localStorage.getItem("followSliderObject")).objectType;
      if (objectType == "company" || objectType == "expert") {
        this.followObject(objectId, objectType);
        localStorage.removeItem("followSliderObject");
      }
    }

  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data.id != this.props.data.id) {
      if (localStorage.getItem("token")) {
        this.setState({
          companies: nextProps.data.companies,
          experts: nextProps.data.experts,
          company_expert_comb: []
        });
        if (nextProps.data.companies && nextProps.data.companies?.length > 0) {
          appendFollowStatus(this.appendFollowCompanyStatusRespHandler, localStorage.getItem("token"), nextProps.data.companies, true);
        }
        if (nextProps.data.experts && nextProps.data.experts?.length > 0) {
          appendFollowStatus(this.appendFollowExpertStatusRespHandler, localStorage.getItem("token"), nextProps.data.experts, false, false, true);
        }
      } else {
        this.setState({
          companies: nextProps.data.companies,
          experts: nextProps.data.experts,
          company_expert_comb: [...nextProps.data.experts, ...nextProps.data.companies],
        });
      }
    }
  }

  appendFollowCompanyStatusRespHandler = (response, error) => {
    this.setState({
      companies: response,
      company_expert_comb: [...this.state.experts, ...this.state.companies],
    });
  }

  appendFollowExpertStatusRespHandler = (response, error) => {
    this.setState({
      experts: response,
      company_expert_comb: [...this.state.experts, ...this.state.companies],
    });
  }

  followButtonClickedRespHandler = (response, error) => {
    this.updateFollowBtnStatus(response.objectId, response.objectType);
  }

  unFollowButtonClickedRespHandler = (response, error) => {
    this.updateFollowBtnStatus(response.objectId, response.objectType);
  }

  followObject = (objectId, objectType) => {
    if (localStorage.getItem("token")) {
      if (objectType == "company") {
        followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), objectId);
      } else if (objectType == "expert") {
        followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), null, null, objectId);
      }
    } else {
      let followObject = { objectId: objectId, objectType: objectType };
      localStorage.setItem("followSliderObject", JSON.stringify(followObject));
      this.props.openSigninModalPopup();
    }
  }

  unFollowObject = (objectId, objectType) => {
    if (objectType == "company") {
      unFollowButtonClicked(this.unFollowButtonClickedRespHandler, localStorage.getItem("token"), objectId);
    } else if (objectType == "expert") {
      unFollowButtonClicked(this.unFollowButtonClickedRespHandler, localStorage.getItem("token"), null, null, objectId);
    }
  }

  updateFollowBtnStatus = (objectId, objectType) => {
    if (this.state.company_expert_comb.length > 0) {
      let updated_company_expert_comb = [];
      Object.values(this.state.company_expert_comb).map(values => {
        if (values?.id == objectId && values.object == objectType) {
          values.isFollowed = !values.isFollowed;
        }
        updated_company_expert_comb.push(values);
      });
      this.setState({
        company_expert_comb: updated_company_expert_comb
      });
    }
  }


  render = () => {
    const events = {
      onDragged: function (event) { },
      onChanged: function (event) { },
      onTranslate: function (event) { }
    };

    return (
      <React.Fragment>
        {this.state.company_expert_comb.length > 0 && (
          <div className="row" key="expertSection">
            <div className={`col-md-12 ${this.state.isEventUI ? "event-expert-wrapper" : ""}`}>
              <h3 className="expert-title">{this.state.isEventUI ? "Companies & topics in this event" : "Experts & companies in this video"}</h3>
              <div className="expert-slider expert-bgchanges">
                <OwlCarousel
                  ref="relatedBlock"
                  options={this.state.options}
                  events={events}
                >
                  {this.state.company_expert_comb.map(function (item, index) {
                    let objectTypeOne = "expert";
                    let objectTypeTwo = "expert";
                    if (index >= this.state.experts?.length) {
                      objectTypeOne = "company";
                    }
                    if (index + 1 >= this.state.experts?.length) {
                      objectTypeTwo = "company";
                    }
                    return (
                      <>
                        {index % 2 == 0 &&
                          <div className="expert-slider-item" key={`expert-slider1-${index}`}>
                            <div className="expert-item" key={`expert-item1-${index}`}>
                              <div className={objectTypeOne === "expert" ? "expert-img expert-circle" : "expert-img"} key={`expert-img1-${index}`}>  
                                <a
                                  href={`/${objectTypeOne}/${item.name}/${item.id}`}
                                  onClick={event => {
                                    if (objectTypeOne === "expert") { 
                                      redirectToExpertUrl(
                                        event,
                                        item.id,
                                        item.name,
                                        this.props,
                                        this.props.showLoader,
                                        this.props.hideLoader
                                      )
                                    } else if (objectTypeOne === "company") {
                                      redirectToCompanyUrl(
                                        event,
                                        item.id,
                                        item.name,
                                        this.props,
                                        this.props.showLoader,
                                        this.props.hideLoader
                                      )
                                    }
                                  }
                                  }
                                >
                                  <img src={item.url || this.state.company_expert_comb[index + 1]?.logo_file_base?.path } alt={item.name + " logo"} style={{ maxWidth: "100%" }} key={`expert-img1-${index}`} />
                                </a>
                              </div>
                              <div className="expert-info" key={`expert-info1-${index}`}>
                                <a
                                  href={`/${objectTypeOne}/${item.name}/${item.id}`}
                                  onClick={event => {
                                    if (objectTypeOne === "expert") {
                                      redirectToExpertUrl(
                                        event,
                                        item.id,
                                        item.name,
                                        this.props,
                                        this.props.showLoader,
                                        this.props.hideLoader
                                      )
                                    } else if (objectTypeOne === "company") {
                                      redirectToCompanyUrl(
                                        event,
                                        item.id,
                                        item.name,
                                        this.props,
                                        this.props.showLoader,
                                        this.props.hideLoader
                                      )
                                    }
                                  }
                                  }
                                >
                                  <h4 key={`expert-name1-${index}`}>{item.name}</h4>
                                  <span key={`expert-industry1-${index}`}>{item.industry?.name}</span>
                                </a>
                              </div>
                              <div className="expert-follow" key={`expert-follow1-${index}`}>
                                <a href="javascript:void(null);" key={`expert-follow1-${index}`} className={item.isFollowed ? "expert-follow-btn hide" : "expert-follow-btn"} onClick={() => this.followObject(item.id, objectTypeOne)} >Follow</a>
                                <a href="javascript:void(null);" key={`expert-unfollow1-${index}`} className={!item.isFollowed ? "expert-unfollow-btn hide" : "expert-unfollow-btn"} onClick={() => this.unFollowObject(item.id, objectTypeOne)}>Following</a>
                              </div>
                            </div>
                            {this.state.company_expert_comb[index + 1]?.name &&
                              <div className="expert-item" key={`expert-item2-${index}`}>
                                <div className={objectTypeTwo === "expert" ? "expert-img expert-circle" : "expert-img"} className="expert-img" key={`expert-img2-${index}`}>
                                  <a
                                    href={`/${objectTypeTwo}/${this.state.company_expert_comb[index + 1].name}/${this.state.company_expert_comb[index + 1].id}`}
                                    onClick={event => {
                                      if (objectTypeTwo === "expert") {
                                        redirectToExpertUrl(
                                          event,
                                          this.state.company_expert_comb[index + 1].id,
                                          this.state.company_expert_comb[index + 1].name,
                                          this.props,
                                          this.props.showLoader,
                                          this.props.hideLoader
                                        )
                                      } else if (objectTypeTwo === "company") {
                                        redirectToCompanyUrl(
                                          event,
                                          this.state.company_expert_comb[index + 1].id,
                                          this.state.company_expert_comb[index + 1].name,
                                          this.props,
                                          this.props.showLoader,
                                          this.props.hideLoader
                                        )
                                      }
                                    }
                                    }
                                  >
                                    <img src={this.state.company_expert_comb[index + 1]?.url || this.state.company_expert_comb[index + 1]?.logo_file_base?.path} alt={this.state.company_expert_comb[index + 1].name + " logo"} style={{ maxWidth: "100%" }} key={`expert-img2-${index}`} />
                                  </a>
                                </div>
                                <div className="expert-info" key={`expert-info2-${index}`}>
                                  <a
                                    href={`/${objectTypeTwo}/${this.state.company_expert_comb[index + 1].name}/${this.state.company_expert_comb[index + 1].id}`}
                                    onClick={event => {
                                      if (objectTypeTwo === "expert") {
                                        redirectToExpertUrl(
                                          event,
                                          this.state.company_expert_comb[index + 1].id,
                                          this.state.company_expert_comb[index + 1].name,
                                          this.props,
                                          this.props.showLoader,
                                          this.props.hideLoader
                                        )
                                      } else if (objectTypeTwo === "company") {
                                        redirectToCompanyUrl(
                                          event,
                                          this.state.company_expert_comb[index + 1].id,
                                          this.state.company_expert_comb[index + 1].name,
                                          this.props,
                                          this.props.showLoader,
                                          this.props.hideLoader
                                        )
                                      }
                                    }
                                    }
                                  >
                                    <h4 key={`expert-name2-${index}`}>{this.state.company_expert_comb[index + 1]?.name}</h4>
                                    <span key={`expert-industry2-${index}`}>{this.state.company_expert_comb[index + 1]?.industry?.name}</span>
                                  </a>
                                </div>
                                <div className="expert-follow" key={`expert-follo2-${index}`}>
                                  <a href="javascript:void(null);" key={`expert-follow2-${index}`} className={this.state.company_expert_comb[index + 1].isFollowed ? "expert-follow-btn hide" : "expert-follow-btn"} onClick={() => this.followObject(this.state.company_expert_comb[index + 1].id, objectTypeTwo)}>Follow</a>
                                  <a href="javascript:void(null);" key={`expert-unfollow2-${index}`} className={!this.state.company_expert_comb[index + 1].isFollowed ? "expert-unfollow-btn hide" : "expert-unfollow-btn"} onClick={() => this.unFollowObject(this.state.company_expert_comb[index + 1].id, objectTypeTwo)}>Following</a>
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </>
                    );
                  }, this)
                  }
                </OwlCarousel>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  };
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      showLoader,
      hideLoader
    },
    dispatch
  );
}


export default connect(null, mapDispatchToProps)(withRouter(RelatedObjectsSlider));
